import { createSelector } from '@ngrx/store';
import { getBaseState } from '../reducers';
import { DistrictState } from './district.reducer';

const getDistrictsState = createSelector(
  getBaseState,
  state => state.districts
);

export const getDistricts = createSelector(
  getDistrictsState,
  (state: DistrictState) => state.districts
);

export const getDistrictsIsLoading = createSelector(
  getDistrictsState,
  (state: DistrictState) => state.districtsActionState.pending
);
